import { stripHtmlTags } from 'utils';

export default ({ File, DocumentMetadata: { Name, OutputFilename } }) => ({
    name: stripHtmlTags(Name || OutputFilename),
    file: `data:application/pdf;base64,${File}`,
});
